import { GET_CONTACT_INFORMATION_SUCCESS } from "../actions/patientAction"


const getContactInformationReducer = (state = [], { type,  data = [] }) => {
    switch (type) {
      case GET_CONTACT_INFORMATION_SUCCESS:
        return data
      default:
        return state
    }
  }
  
  export default getContactInformationReducer